import { makeMessages, makeTranslation } from 'utils'

const messages = {
  payment: 'labels.payment',
  totalNet: 'labels.totalNet',
  totalVat: 'labels.totalVat',
  creditLimitLeft: 'labels.creditLimitLeft',
  totalGross: 'labels.totalGross',
  weightedProductInfo: 'weightedProductInfo',
  orderCta: 'orderCta',
  lackOfDeliveryAddress: { id: 'lackOfDeliveryAddress' },
  floatingPriceText: 'floatingPrice.shortInfo',
  deliveriesCount: 'deliveries.count',
  route: 'labels.route',
  freeDelivery: 'freeDelivery',
  datetimeDeadline: 'deliveries.datetimeDeadline',
  delivery: 'delivery',
  gross: { id: 'prices.gross' },
  forApproval: 'forApproval',
  cartLimitExceededTitle: 'infoBox.cartLimitExceededTitle',
  cartLimitExceededText: 'infoBox.cartLimitExceededText',
  contactBOK: 'infoBox.contactBOK',
  accountBlockedTitle: 'infoBox.accountBlockedTitle',
  accountBlockedOwner: 'infoBox.accountBlockedOwner',
  accountBlocked: 'infoBox.accountBlocked',
  requiresApproval: 'infoBox.requiresApproval',
  creditExceeded: 'infoBox.creditExceeded',
  hasOverdueInvoicesOwner: 'infoBox.hasOverdueInvoicesOwner',
  hasOverdueInvoices: 'infoBox.hasOverdueInvoices',
  payOverdueBills: 'payOverdueBills',
  collapseDescription: 'infoBox.collapseDescription',
  expandDescription: 'infoBox.expandDescription',
  lackToFreeDelivery: 'labels.lackToFreeDelivery',
  showDeliveryDetails: 'deliveries.showDeliveryDetails',
  hideDeliveryDetails: 'deliveries.hideDeliveryDetails',
}

export default makeMessages(messages, makeTranslation('cart'))
